const EU_COUNTRIES = [
  'BE',
  'BG',
  'CZ',
  'DK',
  'DE',
  'EE',
  'IE',
  'EL',
  'ES',
  'FR',
  'HR',
  'IT',
  'CY',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'FI',
  'SE',
];

export function isEuCountry(country?: string): boolean {
  if (!country) {
    return false;
  }
  return EU_COUNTRIES.includes(country);
}

export function getEuCountries(): string[] {
  return EU_COUNTRIES;
}
